// Mirror of BE BatSeq enums. Mode reuses BATTERY_MODE.
export { BATTERY_MODE as BAT_SEQ_MODE } from '../BatteryWidget/batteryConst';

// Mirror of BE ScheduleTimeTypes
export const BAT_SEQ_TYPE = {
    Unknown: 0,
    Start: 100,
    End: 200,
};

// Painter registry key, multi-instance with target = battery rk
export const BAT_SEQ_META_TYPE = 'batSeq';
export const BAT_SEQ_META_VER = 'v1';
export const BAT_SEQ_REGISTRY_KEY = `${BAT_SEQ_META_TYPE}:${BAT_SEQ_META_VER}`;

export const BAT_SEQ_MOVE = {
    Up: -1,
    Down: 1,
};
